// extracted by mini-css-extract-plugin
export var background = "Links-module--background--44bc6";
export var content = "Links-module--content--8204d";
export var heading = "Links-module--heading--f6233";
export var item = "Links-module--item--b5c3d";
export var items = "Links-module--items--8fd02";
export var paragraph = "Links-module--paragraph--2ce55";
export var section = "Links-module--section--6d7bf";